import { gql } from 'apollo-client-ppc';

export const fetchAvailableInvoiceGroups = gql`
  query fetchAvailableInvoiceGroups($id: ID!) {
    transactionAccount(id: $id) {
      id
      updatePaymentMethodLink
      availableInvoiceGroups {
        nodes {
          id
          name
        }
      }
    }
  }
`;
